var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandicon = function SvgBrandicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 8.5A6.5 6.5 0 0 0 8 15c.156 0 .26-.066.303-.117a.319.319 0 0 0 .062-.153c.017-.092.025-.263-.042-.533a2.306 2.306 0 0 0-.146-.364l-.061-.129c-.075-.156-.176-.37-.25-.552-.098-.242-.248-.655-.241-1.13.007-.57.24-1.153.765-1.577.605-.49 1.3-.608 1.831-.625.522-.017 1.06.061 1.478.126l.217.034c.364.057.664.104.959.125.344.024.555 0 .685-.039.348-.107.555-.303.697-.555.16-.28.243-.649.243-1.01a6.5 6.5 0 1 0-13 0Zm6.5 8a8 8 0 1 1 8-8c0 1.129-.5 2.54-2 3-.703.216-1.538.084-2.332-.04-.927-.147-1.797-.284-2.335.151-.398.323-.15.843.116 1.404.128.27.261.548.329.819C10.222 15.61 9.087 16.5 8 16.5Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.088,
    cy: 4.5,
    r: 1.333,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.711,
    cy: 7.167,
    r: 1.333,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.466,
    cy: 7.167,
    r: 1.333,
    fill: "currentColor"
  })));
};
export default SvgBrandicon;